import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, mergeProps as _mergeProps, withModifiers as _withModifiers, vModelText as _vModelText } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "transactions-content"
};
const _hoisted_2 = {
    key: 0,
    class: "loading-state"
};
const _hoisted_3 = { class: "card-header" };
const _hoisted_4 = ["src"];
const _hoisted_5 = {
    key: 1,
    class: "bank-logo-placeholder"
};
const _hoisted_6 = { class: "bank-details" };
const _hoisted_7 = { class: "bank-name" };
const _hoisted_8 = { class: "account-number" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { class: "card-balances" };
const _hoisted_11 = { class: "stat-column stat-column-small" };
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = { class: "stat-column stat-column-small" };
const _hoisted_14 = { class: "stat-amount" };
const _hoisted_15 = { class: "stat-column stat-column-small" };
const _hoisted_16 = ["innerHTML"];
const _hoisted_17 = {
    key: 0,
    class: "stat-column stat-column-merchant"
};
const _hoisted_18 = { class: "stat-amount stat-merchant" };
const _hoisted_19 = { class: "stat-subtext" };
const _hoisted_20 = {
    key: 0,
    class: "uncategorized-banner"
};
const _hoisted_21 = { class: "banner-content" };
const _hoisted_22 = { class: "banner-text" };
const _hoisted_23 = { class: "filter-tabs-wrapper" };
const _hoisted_24 = ["onClick"];
const _hoisted_25 = ["src"];
const _hoisted_26 = { class: "tab-content" };
const _hoisted_27 = { class: "tab-label" };
const _hoisted_28 = { class: "tab-balance" };
const _hoisted_29 = { class: "search-section" };
const _hoisted_30 = ["onClick"];
const _hoisted_31 = { class: "parent-name" };
const _hoisted_32 = {
    key: 0,
    class: "category-children"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = {
    key: 0,
    class: "no-tags"
};
const _hoisted_35 = ["onClick"];
const _hoisted_36 = { class: "tag-label" };
const _hoisted_37 = { class: "date-menu-content" };
const _hoisted_38 = { class: "date-field" };
const _hoisted_39 = { class: "date-field" };
const _hoisted_40 = { class: "date-menu-actions" };
const _hoisted_41 = {
    key: 1,
    class: "search-further-back"
};
import { ref, reactive, computed, watch, onMounted, onBeforeUnmount, nextTick, getCurrentInstance, inject } from 'vue';
import SettingsOverlay from '../components/SettingsOverlay.vue';
import TransactionsTable from '../components/TransactionsTable.vue';
import TransactionTaggingModal from '../components/TransactionTaggingModal.vue';
import { useAppState } from '@/composables/useAppState';
import { useCustomer } from '@/composables/useCustomer';
import { useBanking } from '@/composables/useBanking';
import { useTransactions } from '@/composables/useTransactions';
import { useRecurringPaymentsSidebar } from '@/composables/useRecurringPaymentsSidebar';
import { GRANDPARENT_CLASSIFICATIONS } from '@/composables/useSpendingAnalysis';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TransactionsPage',
    emits: ["colour-mode-changed"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        const state = useAppState();
        const customerApi = useCustomer();
        const banking = useBanking();
        const txns = useTransactions();
        const registerSidebar = inject('registerSidebar', null);
        const colourMode = ref('light');
        const userName = ref('there');
        const showSettings = ref(false);
        // Account data
        const currentAccounts = ref([]);
        const creditAccounts = ref([]);
        const savingAccounts = ref([]);
        // Filter & search state
        const selectedAccountFilter = ref('all');
        const searchQuery = ref('');
        const selectedCategoryFilter = ref('all');
        const selectedCategoryLabel = ref('All Categories');
        const categoryFilterOptions = ref([]);
        const categoryMenuOpen = ref(false);
        const expandedParents = reactive({});
        // Tag filter
        const selectedTags = ref([]);
        const tagMenuOpen = ref(false);
        // Date filter
        const dateMenuOpen = ref(false);
        const dateFrom = ref(null);
        const dateTo = ref(null);
        // Modal state
        const showTransactionModal = ref(false);
        const selectedTransaction = ref(null);
        const bulkMode = ref(false);
        const bulkModeIndex = ref(0);
        // Tags
        const availableTags = ref([]);
        // Loading
        const bankInfoLoaded = ref(false);
        // Scroll arrows
        const canScrollLeft = ref(false);
        const canScrollRight = ref(false);
        // Template ref
        const filterTabs = ref(null);
        // Local transactions state (from bankInfo)
        const transactions = ref([]);
        // Recurring payments sidebar
        const recurringPayments = useRecurringPaymentsSidebar(registerSidebar, {
            onFilterChange: (merchantName) => {
                searchQuery.value = merchantName || '';
            },
            onOpenSettings: () => {
                showSettings.value = true;
            }
        });
        // Watchers
        watch(searchQuery, (newVal) => {
            if (!newVal && recurringPayments.selectedRecurringPaymentId.value) {
                recurringPayments.clearRecurringPaymentFilter();
            }
        });
        // Computed
        const safeTop = computed(() => {
            return parseInt(cookies?.get('st') ?? '0');
        });
        const allAccounts = computed(() => {
            return [...currentAccounts.value, ...creditAccounts.value, ...savingAccounts.value];
        });
        const accountTabs = computed(() => {
            const tabs = [{ value: 'all', label: 'All Accounts', logoUri: null, balance: totalBalance.value }];
            allAccounts.value.forEach((account) => {
                const bankName = account.bank?.name || account.provider || 'Account';
                const accountType = account.accountType?.prettyName || 'Account';
                tabs.push({
                    value: account.id,
                    label: `${bankName} - ${accountType}`,
                    logoUri: account.bank?.logoUri,
                    balance: account.balance
                });
            });
            return tabs;
        });
        const cardGradientStyle = computed(() => {
            const account = selectedAccount.value;
            if (account?.bank?.hexColour1 && account?.bank?.hexColour2) {
                const color1 = '#' + account.bank.hexColour1.slice(2);
                const color2 = '#' + account.bank.hexColour2.slice(2);
                return {
                    background: `linear-gradient(135deg, ${color1} 0%, ${color2} 100%)`
                };
            }
            return { background: 'linear-gradient(135deg, #413655 0%, #5a4a70 100%)' };
        });
        const cardAccentStyle = computed(() => {
            const account = selectedAccount.value;
            if (account?.bank?.hexColour1) {
                const color = '#' + account.bank.hexColour1.slice(2);
                return { borderLeftColor: color };
            }
            return {};
        });
        const selectedAccount = computed(() => {
            if (selectedAccountFilter.value === 'all')
                return null;
            return allAccounts.value.find((a) => a.id === selectedAccountFilter.value);
        });
        const totalBalance = computed(() => {
            return allAccounts.value.reduce((sum, a) => sum + (a.balance || 0), 0);
        });
        const filteredTransactions = computed(() => {
            if (!transactions.value)
                return [];
            if (selectedAccountFilter.value === 'all')
                return transactions.value;
            return transactions.value.map((group) => {
                return group.filter((t) => t.bankAccountID === selectedAccountFilter.value);
            }).filter((group) => group.length > 0);
        });
        const displayTransactions = computed(() => {
            let result = filteredTransactions.value;
            // Category filter
            if (selectedCategoryFilter.value && selectedCategoryFilter.value !== 'all') {
                result = result.map((group) => {
                    return group.filter((t) => {
                        const classification = t.customerClassification || t.effectiveClassification;
                        // Filter uncategorized
                        if (selectedCategoryFilter.value === 'uncategorized') {
                            return !classification || classification.mgClassification === 'Uncategorized';
                        }
                        // Filter by parent category (grandparent)
                        if (selectedCategoryFilter.value.startsWith('parent:')) {
                            const grandparent = parseInt(selectedCategoryFilter.value.split(':')[1]);
                            return classification && classification.grandParentClassification === grandparent;
                        }
                        // Filter by specific category ID
                        return classification && classification.id === selectedCategoryFilter.value;
                    });
                }).filter((group) => group.length > 0);
            }
            // Search filter
            if (searchQuery.value) {
                const q = searchQuery.value.trim().toLowerCase();
                result = result.map((group) => {
                    return group.filter((t) => t.merchantName?.toLowerCase().includes(q) ||
                        (t.merchant?.name || '').toLowerCase().includes(q) ||
                        (t.effectiveClassification?.mgClassification || '').toLowerCase().includes(q) ||
                        (t.effectiveClassification?.mgSubClassification || '').toLowerCase().includes(q) ||
                        t.amount.toString().includes(q) ||
                        (t.customerTags || []).some((tag) => tag.tag.toLowerCase().includes(q)));
                }).filter((group) => group.length > 0);
            }
            // Tag filter
            if (selectedTags.value.length > 0) {
                result = result.map((group) => {
                    return group.filter((t) => {
                        const transactionTags = (t.customerTags || []).map((tag) => tag.tag);
                        return selectedTags.value.some((tag) => transactionTags.includes(tag));
                    });
                }).filter((group) => group.length > 0);
            }
            // Date filter
            if (dateFrom.value || dateTo.value) {
                const fromDate = dateFrom.value ? new Date(dateFrom.value) : null;
                const toDate = dateTo.value ? new Date(dateTo.value) : null;
                if (toDate)
                    toDate.setHours(23, 59, 59, 999);
                result = result.map((group) => {
                    return group.filter((t) => {
                        const txDate = new Date(t.timestamp);
                        if (fromDate && txDate < fromDate)
                            return false;
                        if (toDate && txDate > toDate)
                            return false;
                        return true;
                    });
                }).filter((group) => group.length > 0);
            }
            return result;
        });
        const transactionStats = computed(() => {
            const allTxns = displayTransactions.value.flat();
            const count = allTxns.length;
            // Total spent (negative amounts = spending)
            const totalSpent = allTxns
                .filter((t) => t.amount < 0)
                .reduce((sum, t) => sum + Math.abs(t.amount), 0);
            // Top merchant by spend
            const merchantSpend = {};
            allTxns.filter((t) => t.amount < 0).forEach((t) => {
                const name = t.merchantName || t.merchant?.name || 'Unknown';
                merchantSpend[name] = (merchantSpend[name] || 0) + Math.abs(t.amount);
            });
            let topMerchant = null;
            let topAmount = 0;
            Object.entries(merchantSpend).forEach(([name, amount]) => {
                if (amount > topAmount) {
                    topMerchant = name;
                    topAmount = amount;
                }
            });
            return { count, totalSpent, topMerchant, topMerchantAmount: topAmount };
        });
        const uncategorizedTransactions = computed(() => {
            if (!transactions.value)
                return [];
            const uncategorized = [];
            transactions.value.forEach((group) => {
                group.forEach((t) => {
                    const classification = t.customerClassification || t.effectiveClassification;
                    if (!classification || classification.mgClassification === 'Uncategorized') {
                        uncategorized.push(t);
                    }
                });
            });
            return uncategorized;
        });
        const selectedMerchantCount = computed(() => {
            if (!selectedTransaction.value?.merchantName || !bulkMode.value)
                return 1;
            return uncategorizedTransactions.value.filter((t) => t.merchantName === selectedTransaction.value.merchantName).length;
        });
        const uncategorizedMerchantGroups = computed(() => {
            // Deduplicate uncategorised transactions by merchant — mirrors the mobile grouping
            const seen = new Set();
            return uncategorizedTransactions.value.filter((t) => {
                const key = t.merchantName || t.merchant?.name || t.id;
                if (seen.has(key))
                    return false;
                seen.add(key);
                return true;
            });
        });
        const dateRangeLabel = computed(() => {
            if (!dateFrom.value && !dateTo.value)
                return 'Date';
            if (dateFrom.value && dateTo.value) {
                const from = new Date(dateFrom.value).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
                const to = new Date(dateTo.value).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
                return `${from} - ${to}`;
            }
            if (dateFrom.value) {
                const from = new Date(dateFrom.value).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
                return `From ${from}`;
            }
            const to = new Date(dateTo.value).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
            return `To ${to}`;
        });
        const customer = computed(() => state.customer);
        const formatter = computed(() => state.formatter);
        // Methods
        function updatePref(key, value) {
            if (state.customer?.preferences) {
                state.customer.preferences[key] = value;
                customerApi.savePreferences();
            }
        }
        function selectColourMode(mode) {
            colourMode.value = mode;
            localStorage.setItem('mg_colour_mode', mode);
            emit('colour-mode-changed', mode);
        }
        function loadData() {
            customerApi.getCustomer(() => {
                if (state.customer?.person?.firstName) {
                    userName.value = state.customer.person.firstName;
                }
                getBankInfo();
                // Fetch available tags
                customerApi.getCustomerTags(() => {
                    availableTags.value = state.customerTags?.map((t) => t.tag) || [];
                });
                // Fetch classifications for filter dropdown
                txns.getTransactionClassifications((classifications) => {
                    buildCategoryFilterOptions(classifications);
                });
                // Fetch recurring payments for sidebar
                recurringPayments.fetchAndRegisterRecurringPayments();
            });
        }
        function getBankInfo() {
            banking.getBankingInfo(() => {
                currentAccounts.value = [];
                creditAccounts.value = [];
                savingAccounts.value = [];
                if (state.bankInfo?.accounts) {
                    state.bankInfo.accounts.forEach((a) => {
                        if (a.accountType?.prettyName === 'Current') {
                            currentAccounts.value.push(a);
                        }
                        else if (a.accountType?.prettyName === 'Credit') {
                            creditAccounts.value.push(a);
                        }
                        else if (a.accountType?.prettyName === 'Savings') {
                            savingAccounts.value.push(a);
                        }
                    });
                }
                transactions.value = state.bankInfo?.recentTransactions || [];
                bankInfoLoaded.value = true;
                nextTick(() => updateScrollArrows());
            });
        }
        function formatBalanceWithPence(amount) {
            const formatted = formatter.value.format(Math.abs(amount));
            const parts = formatted.split('.');
            if (parts.length === 2) {
                return `${amount < 0 ? '-' : ''}${parts[0]}.<span class="pence">${parts[1]}</span>`;
            }
            return formatted;
        }
        function openTaggingModal(transaction) {
            selectedTransaction.value = transaction;
            bulkMode.value = false;
            showTransactionModal.value = true;
        }
        function startCategorizing() {
            if (uncategorizedMerchantGroups.value.length === 0)
                return;
            bulkMode.value = true;
            bulkModeIndex.value = 0;
            selectedTransaction.value = uncategorizedMerchantGroups.value[0];
            showTransactionModal.value = true;
        }
        function closeModal() {
            const wasBulkMode = bulkMode.value;
            showTransactionModal.value = false;
            selectedTransaction.value = null;
            bulkMode.value = false;
            bulkModeIndex.value = 0;
            // Refresh after a bulk session so merchant rules applied during tagging are reflected
            if (wasBulkMode) {
                banking.clearBankingInfo();
                getBankInfo();
            }
        }
        function onPreviousUncategorized() {
            const remaining = uncategorizedMerchantGroups.value;
            const currentIndex = remaining.findIndex((t) => t.id === selectedTransaction.value?.id);
            const prev = remaining[currentIndex - 1];
            if (!prev)
                return;
            bulkModeIndex.value = currentIndex - 1;
            selectedTransaction.value = prev;
        }
        function onNextUncategorized() {
            const remaining = uncategorizedMerchantGroups.value;
            const currentIndex = remaining.findIndex((t) => t.id === selectedTransaction.value?.id);
            const next = remaining[currentIndex + 1];
            if (!next) {
                closeModal();
                return;
            }
            bulkModeIndex.value = currentIndex + 1;
            selectedTransaction.value = next;
        }
        function onTransactionTagged(updatedTransaction) {
            if (!transactions.value || !updatedTransaction)
                return;
            // Update the tagged transaction locally
            transactions.value.forEach((group) => {
                const index = group.findIndex((t) => t.id === updatedTransaction.id);
                if (index !== -1) {
                    group.splice(index, 1, { ...group[index], ...updatedTransaction });
                }
            });
            // In bulk mode, also update all other transactions from the same merchant so the
            // entire merchant group drops out of uncategorizedTransactions at once — matching
            // the mobile behaviour where the whole group is removed after tagging one.
            if (bulkMode.value && updatedTransaction.merchantName) {
                transactions.value.forEach((group) => {
                    for (let i = 0; i < group.length; i++) {
                        if (group[i].merchantName === updatedTransaction.merchantName && group[i].id !== updatedTransaction.id) {
                            group.splice(i, 1, {
                                ...group[i],
                                customerClassification: updatedTransaction.customerClassification,
                                effectiveClassification: updatedTransaction.effectiveClassification
                            });
                        }
                    }
                });
            }
            // In bulk mode, never refresh from API mid-session — it would race with the next transaction selection.
            // Refresh happens in closeModal() after the session ends instead.
            if (updatedTransaction?.alwaysApplyTag && !bulkMode.value) {
                banking.clearBankingInfo();
                getBankInfo();
            }
        }
        function handleTagsChange({ transaction, tags }) {
            const updatedTags = tags.map((newTag) => {
                const existingTag = transaction.customerTags?.find((t) => t.tag === newTag);
                if (existingTag) {
                    return { tag: existingTag.tag, id: existingTag.id };
                }
                return { tag: newTag };
            });
            txns.updateTransactionTags(transaction.bankAccountID, transaction.id, updatedTags, () => {
                customerApi.clearCustomerTagsCache();
                // Update the transaction in the local list
                transactions.value.forEach((group) => {
                    const index = group.findIndex((t) => t.id === transaction.id);
                    if (index !== -1) {
                        group[index].customerTags = updatedTags;
                    }
                });
                // Refresh available tags
                customerApi.getCustomerTags(() => {
                    availableTags.value = state.customerTags?.map((t) => t.tag) || [];
                });
            });
        }
        function buildCategoryFilterOptions(classifications) {
            const parentGroups = [
                { name: 'Income', grandparent: GRANDPARENT_CLASSIFICATIONS.INCOME, color: '#B4D8D7' },
                { name: 'Future Plans', grandparent: GRANDPARENT_CLASSIFICATIONS.FUTURE_PLANNING, color: '#D5C9C8' },
                { name: 'Everyday', grandparent: GRANDPARENT_CLASSIFICATIONS.EVERYDAY_SPEND, color: '#9EA2D0' },
                { name: 'Committed', grandparent: GRANDPARENT_CLASSIFICATIONS.FIXED_COSTS, color: '#413655' }
            ];
            const options = [];
            parentGroups.forEach(parent => {
                const categories = classifications.filter((c) => c.mgClassification.grandParentClassification === parent.grandparent);
                if (categories.length > 0) {
                    options.push({
                        title: parent.name,
                        value: `parent:${parent.grandparent}`,
                        color: parent.color,
                        children: categories.map((cat) => ({
                            title: cat.mgClassification.fullName,
                            value: cat.mgClassification.id
                        }))
                    });
                }
            });
            categoryFilterOptions.value = options;
        }
        function selectCategory(value, label) {
            selectedCategoryFilter.value = value;
            selectedCategoryLabel.value = label;
            categoryMenuOpen.value = false;
        }
        function toggleParentExpand(parentValue) {
            expandedParents[parentValue] = !expandedParents[parentValue];
        }
        function toggleTag(tag) {
            const index = selectedTags.value.indexOf(tag);
            if (index === -1) {
                selectedTags.value.push(tag);
            }
            else {
                selectedTags.value.splice(index, 1);
            }
        }
        function clearDates() {
            dateFrom.value = null;
            dateTo.value = null;
        }
        function onRandomiseFiguresChanged() {
            state.formatter.randomiseFigures = null;
        }
        function refreshData() {
            bankInfoLoaded.value = false;
            banking.clearBankingInfo();
            loadData();
        }
        function searchBackTransactions() {
            txns.searchTransactions(searchQuery.value, (result) => {
                transactions.value = result;
            });
        }
        function scrollTabs(direction) {
            const container = filterTabs.value;
            if (!container)
                return;
            const scrollAmount = 200;
            container.scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth'
            });
        }
        function updateScrollArrows() {
            const container = filterTabs.value;
            if (!container)
                return;
            canScrollLeft.value = container.scrollLeft > 0;
            canScrollRight.value = container.scrollLeft < container.scrollWidth - container.clientWidth - 1;
        }
        function downloadCsv() {
            const txnList = displayTransactions.value.flat();
            if (!txnList.length)
                return;
            const headers = ['Date', 'Merchant', 'Description', 'Account', 'Type', 'Parent Category', 'Sub-category', 'Tags', 'Amount', 'Spending Analysis'];
            const rows = txnList.map((t) => {
                const date = new Date(t.timestamp).toLocaleDateString('en-GB');
                const merchant = (t.merchant?.name || t.merchantName || '').replace(/"/g, '""');
                const description = (t.description || '').replace(/"/g, '""');
                const account = (() => {
                    const acct = allAccounts.value.find((a) => a.id === t.bankAccountID);
                    if (!acct)
                        return '';
                    return `${acct.bank?.prettyName || acct.bank?.name || ''} ${acct.accountType?.prettyName || ''}`.trim();
                })();
                const type = t.type === 'DEBIT' ? 'Money Out' : 'Money In';
                const classification = t.customerClassification || t.effectiveClassification;
                const parentCategory = classification?.mgClassification || 'Uncategorized';
                const subCategory = classification?.mgSubClassification || '';
                const tags = (t.customerTags || []).map((tag) => '#' + tag.tag).join(' ');
                const amount = t.amount.toFixed(2);
                const spendingAnalysis = t.excludeFromAnalysis ? 'Excluded' : 'Included';
                return [date, merchant, description, account, type, parentCategory, subCategory, tags, amount, spendingAnalysis].map(v => `"${v}"`).join(',');
            });
            const csv = [headers.join(','), ...rows].join('\n');
            const blob = new Blob([csv], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            const accountName = selectedAccount.value ? (selectedAccount.value.bank?.name || 'Account') : 'All_Accounts';
            a.download = `transactions_${accountName}_${new Date().toISOString().split('T')[0]}.csv`;
            a.click();
            URL.revokeObjectURL(url);
        }
        // Lifecycle
        onMounted(() => {
            const savedMode = localStorage.getItem('mg_colour_mode');
            if (savedMode) {
                colourMode.value = savedMode;
            }
            else {
                colourMode.value = 'light';
                localStorage.setItem('mg_colour_mode', 'light');
            }
            loadData();
            recurringPayments.registerRecurringPaymentsSidebar();
            window.addEventListener('randomise-figures-changed', onRandomiseFiguresChanged);
            nextTick(() => updateScrollArrows());
        });
        onBeforeUnmount(() => {
            window.removeEventListener('randomise-figures-changed', onRandomiseFiguresChanged);
        });
        return (_ctx, _cache) => {
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_menu = _resolveComponent("v-menu");
            const _component_v_checkbox = _resolveComponent("v-checkbox");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["desktop-transactions-page", colourMode.value])
            }, [
                (showSettings.value)
                    ? (_openBlock(), _createBlock(SettingsOverlay, {
                        key: 0,
                        customer: customer.value,
                        colourMode: colourMode.value,
                        safeTop: safeTop.value,
                        onClose: _cache[0] || (_cache[0] = ($event) => (showSettings.value = false)),
                        onUpdatePref: updatePref,
                        onSelectColourMode: selectColourMode
                    }, null, 8, ["customer", "colourMode", "safeTop"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (!bankInfoLoaded.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(_component_v_skeleton_loader, {
                                    type: "card",
                                    height: "120px",
                                    class: "mb-4"
                                }),
                                _createVNode(_component_v_skeleton_loader, {
                                    type: "button",
                                    width: "300px",
                                    class: "mb-4"
                                }),
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                                    return _createVNode(_component_v_skeleton_loader, {
                                        type: "table-row",
                                        key: i
                                    });
                                }), 64))
                            ]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", {
                                    class: "account-summary-card",
                                    style: _normalizeStyle(cardAccentStyle.value)
                                }, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("div", {
                                            class: "bank-logo-frame",
                                            style: _normalizeStyle(cardGradientStyle.value)
                                        }, [
                                            (selectedAccount.value?.bank?.logoUri)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: selectedAccount.value.bank.logoUri,
                                                    class: "bank-logo",
                                                    alt: "Bank logo"
                                                }, null, 8, _hoisted_4))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(selectedAccount.value ? (selectedAccount.value.bank?.name || 'A').charAt(0) : '£'), 1))
                                        ], 4),
                                        _createElementVNode("div", _hoisted_6, [
                                            _createElementVNode("div", _hoisted_7, _toDisplayString(selectedAccount.value ? (selectedAccount.value.bank?.prettyName || selectedAccount.value.bank?.name || 'Account') : 'All Accounts'), 1),
                                            _createElementVNode("div", _hoisted_8, [
                                                _createTextVNode(_toDisplayString(selectedAccount.value ? (selectedAccount.value.accountType?.prettyName || 'Account') : 'Combined View') + " ", 1),
                                                (selectedAccount.value?.accountNumber)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, " · ••••" + _toDisplayString(selectedAccount.value.accountNumber.slice(-4)), 1))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("div", _hoisted_11, [
                                            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "stat-label" }, "Balance", -1)),
                                            _createElementVNode("span", {
                                                class: "stat-amount",
                                                innerHTML: formatBalanceWithPence(selectedAccount.value ? selectedAccount.value.balance : totalBalance.value)
                                            }, null, 8, _hoisted_12)
                                        ]),
                                        _createElementVNode("div", _hoisted_13, [
                                            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "stat-label" }, "Transactions", -1)),
                                            _createElementVNode("span", _hoisted_14, _toDisplayString(transactionStats.value.count), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_15, [
                                            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "stat-label" }, "Spent", -1)),
                                            _createElementVNode("span", {
                                                class: "stat-amount",
                                                innerHTML: formatBalanceWithPence(transactionStats.value.totalSpent)
                                            }, null, 8, _hoisted_16)
                                        ]),
                                        (transactionStats.value.topMerchant)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "stat-label" }, "Top Merchant", -1)),
                                                _createElementVNode("span", _hoisted_18, _toDisplayString(transactionStats.value.topMerchant), 1),
                                                _createElementVNode("span", _hoisted_19, _toDisplayString(formatter.value.format(transactionStats.value.topMerchantAmount)), 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ], 4),
                                (uncategorizedTransactions.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                        _createElementVNode("div", _hoisted_21, [
                                            _createVNode(_component_v_icon, { size: "20" }, {
                                                default: _withCtx(() => _cache[17] || (_cache[17] = [
                                                    _createTextVNode("mdi-tag-outline")
                                                ])),
                                                _: 1
                                            }),
                                            _createElementVNode("span", _hoisted_22, [
                                                _cache[18] || (_cache[18] = _createTextVNode(" You have ")),
                                                _createElementVNode("strong", null, _toDisplayString(uncategorizedTransactions.value.length), 1),
                                                _createTextVNode(" uncategorised transaction" + _toDisplayString(uncategorizedTransactions.value.length === 1 ? '' : 's'), 1)
                                            ])
                                        ]),
                                        _createElementVNode("button", {
                                            class: "start-categorizing-btn",
                                            onClick: startCategorizing
                                        }, " Start Categorising ")
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_23, [
                                    _withDirectives(_createElementVNode("button", {
                                        class: "scroll-arrow scroll-arrow-left",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (scrollTabs('left')))
                                    }, [
                                        _createVNode(_component_v_icon, { size: "20" }, {
                                            default: _withCtx(() => _cache[19] || (_cache[19] = [
                                                _createTextVNode("mdi-chevron-left")
                                            ])),
                                            _: 1
                                        })
                                    ], 512), [
                                        [_vShow, canScrollLeft.value]
                                    ]),
                                    _createElementVNode("div", {
                                        class: "filter-tabs",
                                        ref_key: "filterTabs",
                                        ref: filterTabs,
                                        onScroll: updateScrollArrows
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountTabs.value, (tab) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                                key: tab.value,
                                                class: _normalizeClass(['filter-tab', { active: selectedAccountFilter.value === tab.value }]),
                                                onClick: ($event) => (selectedAccountFilter.value = tab.value)
                                            }, [
                                                (tab.logoUri)
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        src: tab.logoUri,
                                                        class: "tab-logo",
                                                        alt: ""
                                                    }, null, 8, _hoisted_25))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("span", _hoisted_26, [
                                                    _createElementVNode("span", _hoisted_27, _toDisplayString(tab.label), 1),
                                                    _createElementVNode("span", _hoisted_28, _toDisplayString(formatter.value.format(tab.balance)), 1)
                                                ])
                                            ], 10, _hoisted_24));
                                        }), 128))
                                    ], 544),
                                    _withDirectives(_createElementVNode("button", {
                                        class: "scroll-arrow scroll-arrow-right",
                                        onClick: _cache[2] || (_cache[2] = ($event) => (scrollTabs('right')))
                                    }, [
                                        _createVNode(_component_v_icon, { size: "20" }, {
                                            default: _withCtx(() => _cache[20] || (_cache[20] = [
                                                _createTextVNode("mdi-chevron-right")
                                            ])),
                                            _: 1
                                        })
                                    ], 512), [
                                        [_vShow, canScrollRight.value]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_29, [
                                    _createVNode(_component_v_text_field, {
                                        modelValue: searchQuery.value,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((searchQuery).value = $event)),
                                        "prepend-inner-icon": "mdi-magnify",
                                        density: "compact",
                                        label: "Search transactions",
                                        variant: "outlined",
                                        "hide-details": "",
                                        clearable: "",
                                        "single-line": ""
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_v_menu, {
                                        modelValue: categoryMenuOpen.value,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((categoryMenuOpen).value = $event)),
                                        "close-on-content-click": false,
                                        location: "bottom start"
                                    }, {
                                        activator: _withCtx(({ props }) => [
                                            _createElementVNode("button", _mergeProps(props, { class: "category-filter-btn" }), [
                                                _createElementVNode("span", null, _toDisplayString(selectedCategoryLabel.value), 1),
                                                _createVNode(_component_v_icon, { size: "18" }, {
                                                    default: _withCtx(() => _cache[21] || (_cache[21] = [
                                                        _createTextVNode("mdi-chevron-down")
                                                    ])),
                                                    _: 1
                                                })
                                            ], 16)
                                        ]),
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_card, {
                                                class: _normalizeClass(["category-menu", colourMode.value])
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("div", {
                                                        class: _normalizeClass(["category-menu-item", { selected: selectedCategoryFilter.value === 'all' }]),
                                                        onClick: _cache[4] || (_cache[4] = ($event) => (selectCategory('all', 'All Categories')))
                                                    }, " All Categories ", 2),
                                                    _createElementVNode("div", {
                                                        class: _normalizeClass(["category-menu-item", { selected: selectedCategoryFilter.value === 'uncategorized' }]),
                                                        onClick: _cache[5] || (_cache[5] = ($event) => (selectCategory('uncategorized', 'Uncategorized')))
                                                    }, " Uncategorized ", 2),
                                                    _createVNode(_component_v_divider, { class: "my-1" }),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryFilterOptions.value, (parent) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                            key: parent.value,
                                                            class: "category-parent-group"
                                                        }, [
                                                            _createElementVNode("div", {
                                                                class: _normalizeClass(["category-parent-item", { selected: selectedCategoryFilter.value === parent.value }])
                                                            }, [
                                                                _createElementVNode("span", {
                                                                    class: "parent-selectable",
                                                                    onClick: ($event) => (selectCategory(parent.value, parent.title))
                                                                }, [
                                                                    _createElementVNode("span", {
                                                                        class: "parent-color-dot",
                                                                        style: _normalizeStyle({ backgroundColor: parent.color })
                                                                    }, null, 4),
                                                                    _createElementVNode("span", _hoisted_31, _toDisplayString(parent.title), 1)
                                                                ], 8, _hoisted_30),
                                                                _createVNode(_component_v_icon, {
                                                                    size: "18",
                                                                    class: "expand-icon",
                                                                    onClick: _withModifiers(($event) => (toggleParentExpand(parent.value)), ["stop"])
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(expandedParents[parent.value] ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                                                    ]),
                                                                    _: 2
                                                                }, 1032, ["onClick"])
                                                            ], 2),
                                                            (expandedParents[parent.value])
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parent.children, (child) => {
                                                                        return (_openBlock(), _createElementBlock("div", {
                                                                            key: child.value,
                                                                            class: _normalizeClass(["category-child-item", { selected: selectedCategoryFilter.value === child.value }]),
                                                                            onClick: ($event) => (selectCategory(child.value, child.title))
                                                                        }, _toDisplayString(child.title), 11, _hoisted_33));
                                                                    }), 128))
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ]));
                                                    }), 128))
                                                ]),
                                                _: 1
                                            }, 8, ["class"])
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue"]),
                                    _createVNode(_component_v_menu, {
                                        modelValue: tagMenuOpen.value,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((tagMenuOpen).value = $event)),
                                        "close-on-content-click": false,
                                        location: "bottom start"
                                    }, {
                                        activator: _withCtx(({ props }) => [
                                            _createElementVNode("button", _mergeProps(props, { class: "tag-filter-btn" }), [
                                                _createVNode(_component_v_icon, { size: "18" }, {
                                                    default: _withCtx(() => _cache[22] || (_cache[22] = [
                                                        _createTextVNode("mdi-tag-outline")
                                                    ])),
                                                    _: 1
                                                }),
                                                _createElementVNode("span", null, _toDisplayString(selectedTags.value.length ? `${selectedTags.value.length} tag${selectedTags.value.length > 1 ? 's' : ''}` : 'Tags'), 1),
                                                _createVNode(_component_v_icon, { size: "18" }, {
                                                    default: _withCtx(() => _cache[23] || (_cache[23] = [
                                                        _createTextVNode("mdi-chevron-down")
                                                    ])),
                                                    _: 1
                                                })
                                            ], 16)
                                        ]),
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_card, {
                                                class: _normalizeClass(["tag-menu", colourMode.value])
                                            }, {
                                                default: _withCtx(() => [
                                                    (availableTags.value.length === 0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, " No tags available "))
                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableTags.value, (tag) => {
                                                                return (_openBlock(), _createElementBlock("div", {
                                                                    key: tag,
                                                                    class: "tag-menu-item",
                                                                    onClick: ($event) => (toggleTag(tag))
                                                                }, [
                                                                    _createVNode(_component_v_checkbox, {
                                                                        "model-value": selectedTags.value.includes(tag),
                                                                        "hide-details": "",
                                                                        density: "compact",
                                                                        class: "tag-checkbox",
                                                                        onClick: _withModifiers(($event) => (toggleTag(tag)), ["stop"])
                                                                    }, null, 8, ["model-value", "onClick"]),
                                                                    _createElementVNode("span", _hoisted_36, _toDisplayString(tag), 1)
                                                                ], 8, _hoisted_35));
                                                            }), 128)),
                                                            (selectedTags.value.length)
                                                                ? (_openBlock(), _createBlock(_component_v_divider, {
                                                                    key: 0,
                                                                    class: "my-1"
                                                                }))
                                                                : _createCommentVNode("", true),
                                                            (selectedTags.value.length)
                                                                ? (_openBlock(), _createElementBlock("div", {
                                                                    key: 1,
                                                                    class: "clear-tags",
                                                                    onClick: _cache[7] || (_cache[7] = ($event) => (selectedTags.value = []))
                                                                }, " Clear all "))
                                                                : _createCommentVNode("", true)
                                                        ], 64))
                                                ]),
                                                _: 1
                                            }, 8, ["class"])
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue"]),
                                    _createVNode(_component_v_menu, {
                                        modelValue: dateMenuOpen.value,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((dateMenuOpen).value = $event)),
                                        "close-on-content-click": false,
                                        location: "bottom start"
                                    }, {
                                        activator: _withCtx(({ props }) => [
                                            _createElementVNode("button", _mergeProps(props, { class: "date-filter-btn" }), [
                                                _createVNode(_component_v_icon, { size: "18" }, {
                                                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                                                        _createTextVNode("mdi-calendar-range")
                                                    ])),
                                                    _: 1
                                                }),
                                                _createElementVNode("span", null, _toDisplayString(dateRangeLabel.value), 1),
                                                _createVNode(_component_v_icon, { size: "18" }, {
                                                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                                                        _createTextVNode("mdi-chevron-down")
                                                    ])),
                                                    _: 1
                                                })
                                            ], 16)
                                        ]),
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_card, {
                                                class: _normalizeClass(["date-menu", colourMode.value])
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_37, [
                                                        _createElementVNode("div", _hoisted_38, [
                                                            _cache[26] || (_cache[26] = _createElementVNode("label", null, "From", -1)),
                                                            _withDirectives(_createElementVNode("input", {
                                                                type: "date",
                                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((dateFrom).value = $event)),
                                                                class: "date-input"
                                                            }, null, 512), [
                                                                [_vModelText, dateFrom.value]
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_39, [
                                                            _cache[27] || (_cache[27] = _createElementVNode("label", null, "To", -1)),
                                                            _withDirectives(_createElementVNode("input", {
                                                                type: "date",
                                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((dateTo).value = $event)),
                                                                class: "date-input"
                                                            }, null, 512), [
                                                                [_vModelText, dateTo.value]
                                                            ])
                                                        ])
                                                    ]),
                                                    _createVNode(_component_v_divider, { class: "my-1" }),
                                                    _createElementVNode("div", _hoisted_40, [
                                                        _createElementVNode("button", {
                                                            class: "clear-dates-btn",
                                                            onClick: clearDates
                                                        }, "Clear"),
                                                        _createElementVNode("button", {
                                                            class: "apply-dates-btn",
                                                            onClick: _cache[11] || (_cache[11] = ($event) => (dateMenuOpen.value = false))
                                                        }, "Apply")
                                                    ])
                                                ]),
                                                _: 1
                                            }, 8, ["class"])
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue"]),
                                    _createElementVNode("button", {
                                        class: "refresh-btn",
                                        onClick: refreshData
                                    }, [
                                        _createVNode(_component_v_icon, { size: "18" }, {
                                            default: _withCtx(() => _cache[28] || (_cache[28] = [
                                                _createTextVNode("mdi-refresh")
                                            ])),
                                            _: 1
                                        })
                                    ]),
                                    _createElementVNode("button", {
                                        class: "download-csv-btn",
                                        onClick: downloadCsv
                                    }, [
                                        _createVNode(_component_v_icon, { size: "18" }, {
                                            default: _withCtx(() => _cache[29] || (_cache[29] = [
                                                _createTextVNode("mdi-download")
                                            ])),
                                            _: 1
                                        }),
                                        _cache[30] || (_cache[30] = _createElementVNode("span", null, "Export CSV", -1))
                                    ])
                                ]),
                                _createVNode(TransactionsTable, {
                                    transactions: displayTransactions.value,
                                    colourMode: colourMode.value,
                                    formatter: formatter.value,
                                    highlightedTransactionId: selectedTransaction.value?.id,
                                    availableTags: availableTags.value,
                                    stickyHeaderTop: 142,
                                    onTagClick: openTaggingModal,
                                    onTagsChange: handleTagsChange
                                }, null, 8, ["transactions", "colourMode", "formatter", "highlightedTransactionId", "availableTags"]),
                                (searchQuery.value && searchQuery.value.length >= 3)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                        _createElementVNode("button", {
                                            class: "search-further-btn",
                                            onClick: searchBackTransactions
                                        }, [
                                            _createVNode(_component_v_icon, { size: "18" }, {
                                                default: _withCtx(() => _cache[31] || (_cache[31] = [
                                                    _createTextVNode("mdi-history")
                                                ])),
                                                _: 1
                                            }),
                                            _cache[32] || (_cache[32] = _createElementVNode("span", null, "Search Further Back", -1))
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ], 64))
                    ])),
                _createVNode(TransactionTaggingModal, {
                    visible: showTransactionModal.value,
                    "transaction-data": selectedTransaction.value,
                    colourMode: colourMode.value,
                    bulkMode: bulkMode.value,
                    bulkModeIndex: bulkModeIndex.value,
                    bulkModeTotal: bulkMode.value ? uncategorizedMerchantGroups.value.length : 0,
                    merchantCount: selectedMerchantCount.value,
                    onClose: closeModal,
                    onTagged: onTransactionTagged,
                    onNext: onNextUncategorized,
                    onPrevious: onPreviousUncategorized
                }, null, 8, ["visible", "transaction-data", "colourMode", "bulkMode", "bulkModeIndex", "bulkModeTotal", "merchantCount"])
            ], 2));
        };
    }
});
